import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import CashRegisterPdf from './CashRegisterPdf';

const getDate = () => {
    const dateObj = new Date();
    const month = dateObj.getUTCMonth() + 1; // months from 1-12
    const day = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
    return day + "-" + month + "-" + year;
}

const CashRegisterPdfButton = ({ data, version }) => {
    return (
        <PDFDownloadLink document={<CashRegisterPdf data={data} key={version} />} fileName={`Cash-Register-${getDate()}.pdf`}>
            {({ blob, url, loading, error }) =>
                loading ? 'Loading document...' : <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-md shadow">Download PDF</button>
            }
        </PDFDownloadLink>
    );
};

export default CashRegisterPdfButton;
